/*
 * @Author: wangxiaoheng
 * @Date: 2022-12-08 14:52:29
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-12-25 15:07:42
 * @FilePath: \saas_dev\src\utils\api\home.js
 * @Description: 
 * 
 * 
 */
import { post, curlget ,get} from "@/utils/https";
const ali_code = process.env.VUE_APP_ALICODE;
const api = "/xywapi";
// 首页数据
export async function homePageData(param) {
  return await post(`${api}/homePage/getHomePageData`, param);
}
// 分页获取新闻公告
export async function getPageArticle(param) {
  return await post(`${api}/article/getPageArticle`, param);
}
// 分页获取活动
export async function getPageActivity(param) {
  return await post(`${api}/swActivity/page`, param);
}
// 分页获取我的活动
export async function getMYPageActivity(param) {
  return await post(`${api}/swActivity/my`, param);
}
// 获取联系我们
export async function getContactUs() {
  return await post(`${api}/param/getContactUs`);
}

// 活动报名
export async function activityEnroll(param) {
  return await post(`${api}/userWorks/activityEnroll`, param);
}
export async function activityDetail(id) {
  return await post(`${api}/swActivity/getDetail?id=${id}`);
}

// 活动修改
export async function updWorks(param) {
  return await post(`${api}/userWorks/updWorks`, param);
}
// 获取活动专业
export async function getCurrentActivityMajor(param) {
  return await post(`${api}/swMajor/getCurrentActivityMajor`, param);
}
// 学与玩电子刊
export async function sendReadingCode(data) {
  return await post(`${api}/userWorks/sendReadingCode`, data);
}

// 阿里云经纬度逆解析
export async function aliEnLocation(params) {
  return await curlget(`/ali/v3/geocode/regeo`, params, {
    Authorization: `APPCODE ${ali_code}`
  });
}

//公众号h5链接查询作品
export async function getWorkMsg(data) {
  // return await post(`${api}/userWorks/getWorkMsg/${data}`);
  return await post(`${api}/userWorks/getWorkMsg`,data);
}
//公众号h5链接查询教师证书
export async function getcertQuery(data) {
  return await post(`${api}/teacher/certQuery`,data);
}
//h5查看作品
export async function getWorksDetailsByH5(id) {
  return await post(`${api}/userWorks/getWorksDetailsByH5/${id}`);
}
// h5查看证书
export async function getWorksCertificateByH5(id) {
  return await post(`${api}/userWorks/getWorksCertificateByH5/${id}`);
}
// 获取投稿活动
export async function getactivityContributeList() {
  return await post(`${api}/activityContribute/list`);
}
// 根据活动id获取省列表
export async function getAllProvinces(id) {
  return await post(`${api}/swActivity/getZoneIds/${id}`);
}
// 根据省id 获取组赛机构
export async function getChannels(id,zoneId){
  return await post(`${api}/swActivity/getChannels`,{
    activityId:id,
    zoneId:zoneId
  });
}
